import React from "react";
import Damera from "../components/projects/Damera";
import { getSEOData } from "../utils/seo";

export default () => {
  const seoData = getSEOData("royal-damera-gardens-poes-garden");
  return <Damera seoData={seoData} />;
};
